import { Node } from '../../Node';
export class PlaceholderNode extends Node {
  constructor(name, options) {
    super(Object.assign({
      name
    }, options));
  }
}